import { Activity } from "@mapmycustomers/shared/types/entity";

import getEmailLogRecipientName from "./getEmailLogRecipientName";

const filterActivitiesByRecipient = (activities: Activity[], searchText: string): Activity[] => {
  if (!searchText) {
    return activities;
  }
  const searchTextLowered = searchText.toLowerCase();
  return activities.filter((activity) =>
    getEmailLogRecipientName(activity).toLowerCase().includes(searchTextLowered)
  );
};

export default filterActivitiesByRecipient;
